import { render, staticRenderFns } from "./riskPlanInfo.vue?vue&type=template&id=44517387"
import script from "./riskPlanInfo.vue?vue&type=script&lang=js"
export * from "./riskPlanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44517387')) {
      api.createRecord('44517387', component.options)
    } else {
      api.reload('44517387', component.options)
    }
    module.hot.accept("./riskPlanInfo.vue?vue&type=template&id=44517387", function () {
      api.rerender('44517387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/plan/riskPlanInfo.vue"
export default component.exports